module.exports = __webpack_public_path__ + "img/RCloudApache.9eedf067.png";